<template lang="pug">
section(
    ref="container"
    @scroll="handleProductsScroll"
    v-dragscroll
)
    .label(v-if="favoriteProducts.pagination.items.length")
        span.icon
            i.el-icon-fa-bookmark.fas
        span {{ $t('Favorites') }}
    table
        tr.product-table-row
            td.divider(colspan="5")
                hr
        product-preview(
            v-for="product in favoriteProducts.pagination.items" :key="product.id"
            :product="product"
            @add-article-to-cart="$emit('add-article-to-cart', $event)"
            @create-coupon="$emit('create-coupon', $event)"
            @ask-for-refund="$emit('ask-for-refund', $event)"
        )
    .spinner-container(v-if="favoriteProducts.loading")
        .spinner-background
            .spinner
</template>

<i18n>
{
    "de": {
        "Favorites": "Favoriten"
    }
}
</i18n>

<script>
import { useSetupStore, usePosCartStore } from '@/stores';

import ProductPreview from './ProductPreview'

export default {
    data() {
        return {
            favoriteProducts: {
                loading: false,
                pagination: {
                    filters: {},
                    pageInfo: {
                        total: 0,
                        perPage: 8,
                        currentPage: 1,
                        lastPage: 0,
                    },
                    items: []
                }
            },
        };
    },
    components: {
        ProductPreview,
    },
    computed: {
        activeCms() {
            return useSetupStore().activeCms
        },
        posCartStore() {
            return usePosCartStore()
        },
    },
    methods: {
        async loadProducts(page = 1) {
            this.$set(this.favoriteProducts.pagination.pageInfo, 'currentPage', page)

            if (!this.favoriteProducts.pagination.filters) {
                this.$set(this.favoriteProducts.pagination, 'filters', {})
            }
            this.$set(this.favoriteProducts.pagination.filters, 'pos_favorites', {
                key: 'pos_favorites',
                match: true
            })
            this.$set(this.favoriteProducts.pagination.filters, 'shop', {
                key: 'shop',
                match: this.activeCms.shop.id
            })
            // this.$set(this.favoriteProducts.pagination.filters, 'status', {
            //     key: 'status',
            //     match: 'enabled'
            // })

            let payload = {
                variables: {
                    order: 'position',
                    direction: 'asc',
                },
                ...this.favoriteProducts.pagination
            }

            const paginatedProducts = await this.fetchProductsPaginated(payload)
                .catch(err => {
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });

                    console.error(err)
                })

            if (paginatedProducts.items && paginatedProducts.items.length) {
                if (page > 1) {
                    this.favoriteProducts.pagination.items =
                        [...this.favoriteProducts.pagination.items, ...paginatedProducts.items]
                } else {
                    this.favoriteProducts.pagination = paginatedProducts;
                    this.favoriteProducts.visibility = true;
                }
                this.$nextTick(() => {
                    if (this.$refs.container) {
                        // this.$refs.container.style['scroll-behavior'] = 'smooth';
                        this.$refs.container.scrollTop = 0
                    }
                    this.loadMoreProductsIfNeeded(this.$refs.container)
                    // console.log(this.$refs.container)
                })
                this.favoriteProducts.loading = false;
            } else {
                this.query = ''
                // this.$notify.error({
                //     title: this.$t('Could not find any favorite products'),
                //     iconClass: 'fas el-icon-fa-times',
                //     position: 'bottom-left',
                //     customClass: 'dark',
                //     duration: 8000
                // });
            }
        },
        handleProductsScroll(event) {
            const { target } = event;
            this.loadMoreProductsIfNeeded(target)
        },
        loadMoreProductsIfNeeded(target) {
            const currentPage = this.favoriteProducts.pagination.pageInfo.currentPage;
            if (this.favoriteProducts.loading === false && this.favoriteProducts.pagination.pageInfo.lastPage > currentPage) {

                let loadMore = false;
                // const offset = window.innerHeight * 0.8;
                const offset = window.innerHeight;
                if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight - offset) loadMore = true;

                if (loadMore) {
                    this.favoriteProducts.loading = true;
                    this.loadProducts(currentPage + 1)
                }
            }
        },
        fetchProductsPaginated(payload) {
            return this.posCartStore.fetchProductsPaginated(payload);
        }
    },
    mounted() {
        this.loadProducts();
    },
}
</script>

<style lang="sass" scoped>
section
    overflow-y: auto
    table
        width: 100%
        border-spacing: unset
        &::v-deep
            .dimmed
                color: $color-grey-text
            .divider hr
                opacity: 0.5

            .property-container
                display: flex
                gap: 4px
                ::v-deep .property-value
                    padding: 4px 6px
                    background: darken($color-skeleton, 10%)
                    border-radius: 4px
                    font-size: 0.85em
                    label
                        font-size: 0.8em
                        display: block
                        &:after
                            content: ''
            .actions
                .delete-item
                    margin-left: 2rem

            td
                // vertical-align: top
                padding: 2px 0.4rem
                &.info
                    padding-left: 0
                &.min
                    width: 1px
            tr.product-table-row >
                td, th
                    &:first-child
                        padding-left: 0
                    &:last-child
                        padding-right: 0

    .product-preview::v-deep
        width: 100%
        & + .product-preview
            margin-top: 1rem
        .media,
        .placeholder
            top: 35px

.spinner-container
    padding: 10px
    width: 100%
    display: flex
    justify-content: center
    align-items: center
    // background-color: rgba(255,255,255,0.8)
    // backdrop-filter: blur(10px)
    .spinner-background
        background-color: rgba(255,255,255,0.4)
        backdrop-filter: blur(4px)
        padding: 4px
        border-radius: 100px

.label
    background-color: $color-body
    position: sticky
    top: 0
    z-index: 1
    .icon
        display: inline-block
        width: 1rem
        text-align: center
        margin-right: 0.5rem
        i
            margin-right: 0 !important
</style>
